import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/utils/analytics';
import { posthog } from '@/lib/analytics/posthog';
import { readShareArrival } from '@/lib/share';

// The INBOUND half of tracked sharing, renamed from DF-123's
// arrived_via_shared_link: one event now covers both the new UTM links and
// the `?ref=share` ones already out there in people's inboxes, and it carries
// the medium and the creator instead of only a path.
//
// Fires once per page LOAD, not per route change: one arrival is one event,
// and the params stay in the address bar while the visitor clicks around.
// Module scope rather than a ref, so a remount cannot double-count it.
let shareArrivalFired = false;

function captureShareArrival(path: string): void {
    if (shareArrivalFired) return;
    shareArrivalFired = true;
    // Fires NOTHING for an ordinary visit — an "unknown" bucket that swallowed
    // organic traffic would be worse than no row at all.
    const arrival = readShareArrival(window.location.search);
    if (!arrival) return;
    posthog.capture('share_visit', { ...arrival, path });
}

export function usePageTracking(): void {
    const location = useLocation();

    useEffect(() => {
        const url = window.location.origin + location.pathname + location.search + location.hash;
        trackPageView(url);

        captureShareArrival(location.pathname);
    }, [location.pathname, location.search, location.hash]);
}


